import { Component, OnInit, Input, Self, Optional, ViewChild, Output, EventEmitter } from '@angular/core';
import { NgControl, ControlValueAccessor } from '@angular/forms';
import * as uuid from 'uuid';

@Component({
    selector: 'app-form-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
})
export class FormDatepickerComponent implements OnInit, ControlValueAccessor {
    public onChange: (x?: any) => void;

    public onTouched: (x?: any) => void;

    public id: string;

    public _value: any = '';

    public mask = {
        guide: false,
        showMask: false,
        mask: [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/],
    };

    @Input() large: boolean = false;

    @Input() disabled: boolean;

    @Input() label = '';

    /** Optional helper text rendered as a subtitle directly under the label. */
    @Input() subtitle = '';

    @Input() placeholder: string = this.label;

    @Input() type: 'text' | 'email' | 'password' | 'number' = 'text';

    @Input() validation = true;

    @Input() max: Date;

    @Input() min: Date;

    @Input() invalidPass: boolean;

    @Input() showMessages: boolean = true;

    @Output('change') changeOutput = new EventEmitter<any>();

    @ViewChild('input', { static: true }) input;

    @ViewChild('picker', { static: true }) picker;

    constructor(@Self() @Optional() private ngControl: NgControl) {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }

    get value(): any {
        return this._value;
    }

    set value(v) {
        this._value = v;
        if (this.onChange) {
            this.changeOutput.emit(v);
            this.onChange(v);
            this.onTouched();
        }
    }

    change(v): void {
        this.value = v;
    }

    get invalid(): boolean {
        if (this.ngControl) {
            return this.ngControl.invalid;
        }
        return false;
    }

    get valid(): boolean {
        if (this.ngControl) {
            return this.ngControl.valid;
        }
        return false;
    }

    get pristine(): boolean {
        if (this.ngControl) {
            return this.ngControl.pristine;
        }
        return false;
    }

    get dirty(): boolean {
        if (this.ngControl) {
            return this.ngControl.dirty;
        }
        return false;
    }

    get touched(): boolean {
        if (this.ngControl) {
            return this.ngControl.touched;
        }
        return false;
    }

    ngOnInit(): void {
        this.id = uuid.v4();
    }

    writeValue(value: any): void {
        this._value = value;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    registerOnChange(fn: any): void {
        // Store the provided function as an internal method.
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        // Store the provided function as an internal method.
        this.onTouched = fn;
    }
}
